import moment from 'moment';

export const INITIAL_STATE = {
    isComplete:false,
    isDismounted:false,
    faultDesc:'',
    mountingAddress:'',
    purchaseAddress:'',
    faultDate:moment(),
    serialNumber:'',
    purchaseProveFile:[],
    additionalFiles:[],
    quantityCorrectionsProposals:''
};


// WEBPACK FOOTER //
// ./src/reducers/state/CreateXLComplaint.js